const futureGiveback = () => {
  $(window).on('load resize', function () {
    if (window.template_type !== 'collection') {
      if ($(window).width() >= 1181) {
        $('.future-giveback .content-box').slick('unslick');
      } else {
        $('.future-giveback .content-box').slick({
          dots: false,
          arrows: false,
          slidesToShow: 2,
          slidesToScroll: 2,
          settings: 'unslick',
          responsive: [
            {
              breakpoint: 1181,
              settings: {
                variableWidth: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 767,
              settings: {
                variableWidth: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
    }
  });
}; // Mobile/tab Only Slider

export default futureGiveback;
